import {
  DebouncedTextInput,
  Group,
  GroupItem,
  Toolbar,
  useSaveMutation,
} from "ra-friendsofbabba";
import {
  SimpleForm,
  required,
  useNotify,
  useQueryWithStore,
  useRedirect,
} from "react-admin";

import MonthInput from "../component/input/MonthInput";
import React from "react";

const Form = (props) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const { data: config } = useQueryWithStore({
    type: "get",
    resource: "executive-project-wp-deliverables/config",
    payload: {
      ...props?.record,
    },
  });
  const save = useSaveMutation({
    ...props,
    onSuccess: (response, values) => {
      notify(
        `resources.executive-project-wp-deliverables.messages.save_success`
      );
      redirect(`/executive-project-wps/${values?.executive_project_wp_id}`);
    },
  });

  return (
    <SimpleForm
      {...props}
      save={save}
      toolbar={
        <Toolbar
          backTab={0}
          backReference="executive-project-wps"
          backReferenceTarget="executive_project_wp_id"
        />
      }
    >
      <DebouncedTextInput
        source="name"
        validate={required()}
        maxLength={100}
        fullWidth
      />
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6} xs={12}>
          <MonthInput
            source="expected_month"
            validate={required()}
            minValue={config?.data?.min_month}
            maxValue={config?.data?.max_month}
            helperText={`resources.executive-project-wp-deliverables.fields.expected_month.help`}
          />
        </GroupItem>
      </Group>

      <DebouncedTextInput
        source="description"
        validate={required()}
        maxLength={4000}
        fullWidth
        multiline
      />
    </SimpleForm>
  );
};
export default Form;
